var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBathLinerShowerEnclosure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bath-liner-shower-enclosure",
    viewBox: "0 0 151.3 163.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 110.8,
    width: 147.8,
    height: 50.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.9 110.8h-145.1c-0.9 0-1.4-1.1-0.8-1.7l2.6-2.9c0.9-1 2.2-1.6 3.6-1.6h136c1.8 0 3.4 1 4.2 2.5l0.7 1.3c0.8 1.1 0 2.4-1.2 2.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1.8 110.8 1.8 2.3 12.9 5.2 68.3 5.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "149.6 110.8 149.6 2.3 138.4 5.2 58.4 5.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9,
    x2: 12.9,
    y1: 5.2,
    y2: 104.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.4,
    x2: 138.4,
    y1: 5.2,
    y2: 103.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9,
    x2: 26.7,
    y1: 61.6,
    y2: 61.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9,
    x2: 26.7,
    y1: 80.1,
    y2: 80.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.4,
    x2: 124.7,
    y1: 61.6,
    y2: 61.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.4,
    x2: 124.7,
    y1: 80.1,
    y2: 80.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118.3 27.3-0.9 0.9c-0.2 0.2-0.3 0.5-0.3 0.8s0.1 0.5 0.3 0.7 0.4 0.3 0.7 0.3 0.5-0.1 0.7-0.3l0.9-0.9c0.2-0.2 0.3-0.5 0.3-0.8s-0.1-0.5-0.3-0.7c-0.3-0.4-1-0.4-1.4 0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m113.8 34.4c0.3 0 0.6-0.1 0.8-0.3l0.9-0.9c0.4-0.4 0.4-1.1 0-1.5s-1.1-0.4-1.5 0l-0.9 0.9c-0.4 0.4-0.4 1.1 0 1.5 0.1 0.2 0.4 0.3 0.7 0.3z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m109.5 36.1-0.9 0.9c-0.2 0.2-0.3 0.5-0.3 0.7 0 0.3 0.1 0.6 0.3 0.8s0.5 0.3 0.8 0.3 0.5-0.1 0.8-0.3l0.9-0.9c0.2-0.2 0.3-0.5 0.3-0.8s-0.1-0.6-0.3-0.8c-0.5-0.3-1.2-0.3-1.6 0.1z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m121.8 34c0.2 0.1 0.4 0.2 0.6 0.2 0.3 0 0.7-0.2 0.9-0.4l0.8-1.1c0.3-0.5 0.2-1.1-0.2-1.5-0.2-0.1-0.4-0.2-0.6-0.2-0.3 0-0.7 0.2-0.9 0.5l-0.8 1.1c-0.2 0.2-0.2 0.5-0.2 0.8 0 0.2 0.2 0.5 0.4 0.6z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m118.7 36.6-0.8 1.1c-0.3 0.5-0.2 1.1 0.3 1.5 0.2 0.1 0.4 0.2 0.6 0.2 0.3 0 0.7-0.2 0.9-0.4l0.7-1.1c0.2-0.2 0.2-0.5 0.2-0.8s-0.2-0.5-0.4-0.7c-0.5-0.4-1.2-0.3-1.5 0.2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m114 25.8c0.2 0 0.4-0.1 0.6-0.2l1.1-0.7c0.2-0.2 0.4-0.4 0.4-0.7s0-0.6-0.2-0.8c-0.2-0.3-0.5-0.4-0.9-0.4-0.2 0-0.4 0.1-0.6 0.2l-1.1 0.8c-0.5 0.3-0.6 1-0.3 1.5 0.3 0.1 0.6 0.3 1 0.3z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m108.9 29.4c0.2 0 0.4-0.1 0.6-0.2l1.1-0.8c0.5-0.3 0.6-1 0.3-1.5-0.2-0.3-0.5-0.4-0.9-0.4-0.2 0-0.4 0.1-0.6 0.2l-1.1 0.8c-0.5 0.3-0.6 1-0.3 1.5 0.2 0.2 0.5 0.4 0.9 0.4z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m135.8 14.8h0.6v-2.1h-0.6c-1.8 0-3.6 0.7-4.9 2l-2.1 2.1-0.2-0.2c-1.7-1.3-3.7-1.9-5.8-1.9-2.6 0-5 1-6.8 2.8-0.2 0.2-0.3 0.5-0.3 0.7 0 0.3 0.1 0.6 0.3 0.8l12 12c0.4 0.4 1.1 0.4 1.5 0 3.3-3.4 3.7-8.7 0.9-12.5l-0.2-0.2 2.1-2.1c1-0.9 2.2-1.4 3.5-1.4zm-6.7 13.6-0.2 0.3-10.4-10.4 0.3-0.2c1.2-0.8 2.7-1.3 4.2-1.3 2.5 0 4.8 1.2 6.2 3.3 1.6 2.5 1.6 5.8-0.1 8.3z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m138.7 96.5c-3.8-1.1-7.6-2.5-11.6-2.6l0.2-2c1.9 0.5 3.9 0.5 5.9 0.5s4-0.1 6-0.2l-0.5 4.3z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.11 -.9939 .9939 .11 20.806 210.55)",
    cx: 128,
    cy: 93.7,
    rx: 0.8,
    ry: 1.9,
    fill: "#fff",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.6719
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathLinerShowerEnclosure);
export default __webpack_public_path__ + "static/media/bath-liner-shower-enclosure.6f3dde239b65f61e4de751a584791d4f.svg";
export { ForwardRef as ReactComponent };